__turbopack_context__.v({
  "root": "quoted-tweet-body-module__qHviCq__root",
});
